export default [
  {
    prop: 'price',
    label: '充值金额',
    tips: '含服务费',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'channel_name',
    label: '签约主体',
    minWidth: 160,
    tooltip: true
  },
  {
    prop: 'rate',
    label: '服务费率',
    tooltip: true,
    minWidth: 100
  },
  {
    prop: 'mch_price',
    label: '商户号充值金额',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'mch_id',
    label: '充值商户号',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'service_price',
    label: '服务费',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'recharge_type',
    label: '充值类型',
    minWidth: 100
  },
  {
    prop: 'create_time',
    label: '充值时间',
    minWidth: 160,
    tooltip: true
  },
  {
    prop: 'status',
    label: '状态',
    minWidth: '100px'
  },
  {
    prop: 'action',
    width: '130px',
    label: '操作'
  }
]
